import router, { resetRouter } from './router'
import store from './store'
import { getToken } from './utils/auth'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const whiteList = ['/login']

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (!store.state.system.configLoaded) {
        try {
          await store.dispatch('system/fetchConfig')
        } catch (error) {
          // Keep navigation usable even if system config request fails.
        }
      }
      if (!store.state.user.role) {
        const info = await store.dispatch('user/getInfo')
        const accessRoutes = await store.dispatch('permission/generateRoutes', {
          menus: info.menus || [],
          permissionCodes: info.permission_codes || info.permissionCodes || []
        })
        accessRoutes.forEach(route => router.addRoute(route))
        next({ ...to, replace: true })
      } else {
        next()
      }
    }
  } else if (whiteList.includes(to.path)) {
    next()
  } else {
    resetRouter()
    next(`/login?redirect=${to.path}`)
    NProgress.done()
  }
})

router.afterEach(() => {
  NProgress.done()
})
